import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import {PlayCircleOutlined, PauseCircleOutlined} from "@ant-design/icons-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AudioItem',
  props: {
    url: {},
    name: {},
    active: { type: Boolean },
    playStat: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({active: _ctx.active})
  }, [
    (_ctx.playStat)
      ? (_openBlock(), _createBlock(_unref(PauseCircleOutlined), { key: 0 }))
      : (_openBlock(), _createBlock(_unref(PlayCircleOutlined), { key: 1 })),
    _createElementVNode("span", null, _toDisplayString(_ctx.name), 1)
  ], 2))
}
}

})